import { useLayoutEffect } from "react";
import { type ColorTokens, useTheme } from "tamagui";

const claims: { color: string }[] = [];

const paint = () => {
  const color = claims.at(-1)?.color ?? "";
  document.documentElement.style.backgroundColor = color;
  document.body.style.backgroundColor = color;
};

/** iOS Safari tints its bars from the page background. */
export const usePageBackground = (token: ColorTokens | undefined) => {
  const theme = useTheme();
  const color = token === undefined ? undefined : theme[token]?.val;
  useLayoutEffect(() => {
    if (color === undefined) {
      return;
    }
    const claim = { color: String(color) };
    claims.push(claim);
    paint();
    return () => {
      claims.splice(claims.indexOf(claim), 1);
      paint();
    };
  }, [color]);
};
